import { Component, OnInit, Renderer2, ElementRef, ViewChild, Inject, Injectable } from '@angular/core';
import { navItems } from '../../_nav';
import { environment } from '../../../environments/environment';
import { SocketService } from "../../socket-service/socket.service";
import { SettingService } from '../../views/settings/setting-service/setting.service';
import { OrderService } from '../../views/orders/order-service/order.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser'
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styles: [`
    :host ::ng-deep .navbar-brand {
      justify-content: flex-start;
      width: fit-content;
      margin-left: 10px;
    }
  `]
})
@Injectable({ providedIn: 'root' })
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  public navItems = navItems;
  showDropDown = false;
  showDropDownNoti = false;
  orderList = [];
  notificationList = [];
  count: any
  number: number;
  orderCount: number;

  adminId: any;
  start = 0;
  limit = 10;
  logo = ''

  @ViewChild('toggleButton') toggleButton: ElementRef;
  @ViewChild('menu') menu: ElementRef;
  @ViewChild('menulist') menulist: ElementRef;

  constructor(
    private socketService: SocketService,
    private settingService: SettingService,
    private orderService: OrderService,
    private renderer: Renderer2,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public location: Location,
    private toastr: ToastrService,
    private titleService: Title,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private http: HttpClient,
  ) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.menu) {
        if (e.target !== this.toggleButton.nativeElement && e.target !== this.menu.nativeElement) {
          this.showDropDown = false;
        }
      }
      if (this.menulist) {
        if (e.target !== this.toggleButton.nativeElement && e.target !== this.menulist.nativeElement) {
          this.showDropDownNoti = false;
        }
      }
    });

  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  image = '';

  ngOnInit(): void {
    this.settingService.getGeneralSettingDetail().subscribe((data: any) => {
      if (data.status) {
        this.image = environment.apiUrl + data.response.image;
        this.logo = environment.apiUrl + data.response.logo;
        // if(data.response.favicon){
        //   this._document.getElementById('appFavicon').setAttribute('href', environment.apiUrl + data.response.favicon);
        // } else {
        this._document.getElementById('appFavicon').setAttribute('href', 'assets/favicon.ico');
        // }
        this._document.getElementsByClassName('img-avatar')[0].setAttribute('src', this.logo);
      }
    });

    this.socketService.eventEmitter.subscribe(data => {
      this.image = environment.apiUrl + data.image;
    });

    this.orderService.notifyObservable$.subscribe((res) => {
      this.getNotification();
    })

    this.settingService.notifyObservable$.subscribe((res) => {
      this.getNotificationRetailer();
    })

    this.getNotification();
    this.getNotificationRetailer();
    this.listenSocketRetaileraddOrder();
    this.listenSocketRetailerNotific();
    // this.adminSiteTitle();
  }
  // adminSiteTitle() {
  //   this.socketService.listen('adminsettingTitle').subscribe((data: any) => {
  //     this.titleService.setTitle(data.site_title);
  //   });
  // }

  listenSocketRetaileraddOrder() {
    this.socketService.listen('admingetorder').subscribe((data: any) => {
      this.getNotification();
    });
  }

  listenSocketRetailerNotific() {
    this.socketService.listen('getnotific').subscribe((data: any) => {
      this.getNotificationRetailer();
    });
  }

  getNotification() {
    this.settingService.getNotificationDetail().subscribe((data: any) => {
      if (data.status) {
        this.orderCount = data.response.length != 0 ? data.response : 0;
      }
    });
  }

  getNotificationRetailer() {
    var currentuser = localStorage.getItem('userDetail');
    var userData = JSON.parse(currentuser);

    this.settingService.getNotificationCount().subscribe((data: any) => {
      if (data.status) {
        this.number = data.response.count;
        this.notificationList = data.response.documet;
      }
    });

  }

  notificationListComp() {
    this.notificationList.map(async (detail) => {
      this.adminId = detail.admin_id;
    })
    this.router.navigate(['notification'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        id: this.adminId
      },
      queryParamsHandling: 'merge',
    })
  }

  signOut() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('userDetail');
    localStorage.removeItem('userId');
  }

  viewNotification() {
    console.log('view notification');
  }

  onClickedOutside(e: Event) {
    this.showDropDown = false;
    this.showDropDownNoti = false;
  }

  openNotification() {
    this.router.navigate(['/order/neworder']);
    this.showDropDown = !this.showDropDown;
    this.showDropDownNoti = !this.showDropDownNoti;
  }

  // viewDetails(item) {
  //   this.router.navigate(['/order/neworder'], 
  //     {
  //       relativeTo: this.activatedRoute,
  //       queryParams: { id: item.orderId },
  //       queryParamsHandling: 'merge'
  //     }
  //   );

  //   this.orderList.forEach((value, key) => {
  //     if (value.orderId == item.orderId) {
  //       this.orderList.splice(key, 1);
  //       this.orderCount = this.orderList.length
  //     }
  //   })
  // }

  goSetting() {
    this.router.navigate(['/settings/general']);
  }
}
